// extracted by mini-css-extract-plugin
export var dataCell = "_kd-2";
export var dataRow = "_kd-0";
export var headerRow = "_kd-1";